import { Injectable } from '@angular/core';
import { PositionsService as CmbPositionsApi } from '@bluecrew/crew-member-backend-angular-client';

/**
 * Connects to CMOS PositionService for position/job aggregation. May do filtering for LAN session.
 */
@Injectable({
  providedIn: 'root'
})
export class PositionService {

  constructor(
    private cmbPositionsApi: CmbPositionsApi,
  ) { }

  getPotentialPositions() {
    return this.cmbPositionsApi.getPotentialPositions();
  }

  getPosition(positionId) {
    return this.cmbPositionsApi.getPosition(positionId);
  }

  getPositionAnonymous(positionId) {
    return this.cmbPositionsApi.getPositionAnonymous(positionId);
  }

  getPositionFromJobId(jobId) {
    return this.cmbPositionsApi.getPositionFromJobId(jobId);
  }

  getPositionFromJobIdAnonymous(jobId) {
    return this.cmbPositionsApi.getPositionFromJobIdAnonymous(jobId);
  }

  rejectJob(jobId: string, reason: string) {
    return this.cmbPositionsApi.rejectJob(jobId, {reason: reason});
  }
}
